import React from "react";
import OmniCurrentStockTable from "../omniStockTable/omniCurrentStockTable";
import StockTakeTable from "../stockTakeTable/stockTakeTable";
import VarianceReportTable from "../varianceReportTable/varianceReportTable";

import { Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/actions";
import { useLabsStock } from "../../context/LabsStockContext";

const ExpandedRow = ({ record }) => {
    const dispatch = useDispatch();
    const { reportsGenerated, varianceReports, wareHouseId: contextWareHouseId } = useLabsStock();
    const visibleRegisters = useSelector(
        state => state.labsStockManagementReducer.allstockManagementRegisters || []
    );

    // Use the warehouse on the register itself; a shared context value can
    // refer to a different expanded row when multiple labs are on screen.
    const warehouseId = Number(
        record?.labSetup?.wareHouseId ?? record?.wareHouseId ?? contextWareHouseId
    );

    // One bulk request for only the visible registers belonging to THIS warehouse.
    // Keep the expanded register first so it is always included (API limit: 50).
    const registerIds = [record.id, ...visibleRegisters
        .filter(item => Number(item?.labSetup?.wareHouseId ?? item?.wareHouseId) === warehouseId)
        .map(item => item.id)]
        .map(Number)
        .filter((id, index, ids) => Number.isSafeInteger(id) && id > 0 && ids.indexOf(id) === index)
        .slice(0, 50);

    const recordId = String(record.id);
    const isVarianceGenerated =
        reportsGenerated[recordId] ||
        (record.varianceReports && record.varianceReports.length > 0) ||
        (record.variance_reports && record.variance_reports.length > 0) ||
        (Array.isArray(varianceReports[recordId]) && varianceReports[recordId].length > 0);

    const hasVarianceReports =
        (record.varianceReports && record.varianceReports.length > 0) ||
        (record.variance_reports && record.variance_reports.length > 0) ||
        (Array.isArray(varianceReports[recordId]) && varianceReports[recordId].length > 0);

    const hasAttemptedFetch = reportsGenerated[recordId] || Object.prototype.hasOwnProperty.call(varianceReports, recordId);

    React.useEffect(() => { 
        if (recordId && !hasAttemptedFetch && !hasVarianceReports) {
            dispatch(actions.fetchAllVarianceReports(recordId));
        }
    }, [recordId, dispatch, hasAttemptedFetch, hasVarianceReports]);

    return (
        <div style={{ padding: "20px 0px" }}>
            <Row gutter={[16, 16]} className="stock-expanded-row-container">
                {isVarianceGenerated && (
                    <Col span={24} key="variance-report-col">
                        <VarianceReportTable registerId={record.id} record={record} />
                    </Col>
                )}
                <Col span={10} key="omni-stock-col">
                    <OmniCurrentStockTable
                        registerId={record.id}
                        warehouseId={warehouseId}
                        registerIds={registerIds}
                    />
                </Col>
                <Col span={14} key="stock-take-col">
                    <StockTakeTable recordId={record.id} />
                </Col>
            </Row>
        </div>
    );
};

export default ExpandedRow;
